import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandMicrosoft(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path d="M2.4 2.4h19.2v19.2H2.4V2.4Z" fill="#F3F3F3" />
      <path d="M3.235 3.235h8.348v8.348H3.235V3.235Z" fill="#F35325" />
      <path d="M12.418 3.235h8.348v8.348h-8.348V3.235Z" fill="#81BC06" />
      <path d="M3.235 12.417h8.348v8.348H3.235v-8.348Z" fill="#05A6F0" />
      <path d="M12.418 12.417h8.348v8.348h-8.348v-8.348Z" fill="#FFBA08" />
    </BaseIcon>
  );
}
